import clsx from 'clsx';

export type TimeRangeKey = '6h' | '24h' | '7d' | '30d' | 'all';

export interface TimeRange {
  from?: string;
  to?: string;
  bucketMinutes: number;
}

const RANGES: { key: TimeRangeKey; label: string; hours: number | null; bucketMinutes: number }[] = [
  { key: '6h', label: '6h', hours: 6, bucketMinutes: 15 },
  { key: '24h', label: '24h', hours: 24, bucketMinutes: 30 },
  { key: '7d', label: '7d', hours: 7 * 24, bucketMinutes: 180 },
  { key: '30d', label: '30d', hours: 30 * 24, bucketMinutes: 720 },
  { key: 'all', label: 'All', hours: null, bucketMinutes: 1440 },
];

interface TimeRangeSelectorProps {
  value: TimeRangeKey;
  onChange: (key: TimeRangeKey, range: TimeRange) => void;
}

export function computeRange(key: TimeRangeKey): TimeRange {
  const def = RANGES.find((r) => r.key === key)!;
  if (!def.hours) return { bucketMinutes: def.bucketMinutes };
  const now = new Date();
  return { from: new Date(now.getTime() - def.hours * 60 * 60 * 1000).toISOString(), to: now.toISOString(), bucketMinutes: def.bucketMinutes };
}

export default function TimeRangeSelector({ value, onChange }: TimeRangeSelectorProps) {
  return (
    <div className="flex items-center gap-2">
      <div className="inline-flex items-center rounded bg-gray-100 dark:bg-gray-800/80 p-0.5">
        {RANGES.map((r) => (
          <button
            key={r.key}
            onClick={() => onChange(r.key, computeRange(r.key))}
            className={clsx(
              'px-2.5 py-1 text-[11px] font-medium rounded-md transition-all',
              r.key === value
                ? 'bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 shadow-sm'
                : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300',
            )}
          >
            {r.label}
          </button>
        ))}
      </div>
      <span className="relative flex h-2 w-2">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" />
        <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500" />
      </span>
    </div>
  );
}
